import { Grid, Link, Typography } from '@material-ui/core';
import { useRouteMatch } from 'react-router-dom';

export default function Copyright({ isDark = false, onSecretClick }) {
  const textColor = isDark ? 'black' : 'rgba(255, 255, 255, 0.7)';
  const fontStyle = {
    fontFamily: 'Janda Manatee Solid, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  };

  const isScrollablePage = useRouteMatch([
    '/topics/:topicId/:topicSlug/:childId/:childSlug/aprender',
    '/topics/:topicId/:topicSlug/:childId/:childSlug/aprender/:groupId',
    '/topics/:id-:name/:cid-:cname',
  ]);

  return (
    <Grid style={{ justifyContent: 'space-between', ...(isScrollablePage ? { padding: '15px 0' } : {}) }} container>
      <Typography
        variant="body2"
        color="textPrimary"
        align="center"
        style={{ ...fontStyle, color: textColor, letterSpacing: '0.04em', transform: 'scaleX(1.1)', transformOrigin: 'left' }}
      >
        {onSecretClick ? (
          <span onClick={onSecretClick} style={{ cursor: 'pointer', outline: 'none' }}>
            {`©${new Date().getFullYear()} `}
          </span>
        ) : (
          `©${new Date().getFullYear()} `
        )}
        <Link color="inherit" href="https://vivamosspanish.com/" target="_blank" style={{ textDecoration: 'none' }}>
          Vivamos Spanish
        </Link>
      </Typography>
      <Typography
        variant="body2"
        color="textPrimary"
        align="center"
        style={{
          ...fontStyle,
          color: textColor,
          letterSpacing: '0.04em',
          transform: 'scaleX(1.1)',
          transformOrigin: 'right',
        }}
      >
        <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>
          Privacy Policy
        </a>
      </Typography>
    </Grid>
  );
}
